import { HubConnection } from "@microsoft/signalr";
import {
  createSetFleetManagerHubAction,
  SET_FLEET_MANAGER_HUB,
} from "../actions/fleetManagerHub";

export interface IFleetManagerHubState {
  hub?: HubConnection;
}

export const initialFleetManagerHubState: IFleetManagerHubState = {};

export const fleetManagerHubReducer = (
  previousState: IFleetManagerHubState = initialFleetManagerHubState,
  action: ReturnType<typeof createSetFleetManagerHubAction>
) => {
  switch (action.type) {
    case SET_FLEET_MANAGER_HUB:
      return {
        ...previousState,
        hub: action.payload.hub,
      };
    default:
      return previousState;
  }
};
